import { LAQUO, MDASH, NBSP, RAQUO } from '@r1-frontend/ui-react/tokens/symbols';

import type { IData, TTabs } from '~/src/features/videocontrol/pageBlocks/Advantages/types';
import type { IFeaturesData, IHeaderItems, IHeaderPictures } from '~/src/features/videocontrol/pageBlocks/Header/types';
import { TArticle } from '~/src/features/videocontrol/pageBlocks/Questions';
import type { TTabSteps } from '~/src/features/videocontrol/pageBlocks/StepsInstall/LocationTabsBlock/types';
import type { TInjector, TPlace } from '~/src/features/videocontrol/Provider/types';
import type { IDataPlans } from '~/src/features/videocontrol/types';

export const faqData: TArticle[] = [
    {
        id: 1,
        question: `Как подключить умные камеры от${NBSP}Дом.ру?`,
        answer: `<p>1. Оставьте заявку на${NBSP}сайте dom.ru, либо через контакт центр. Наш координатор перезвонит вам` +
            `, чтобы спланировать время доставки и${NBSP}установки камеры.</p>` +
            `<p>2. Подключите камеру через WI-FI или напрямую к${NBSP}роутеру с${NBSP}помощью кабеля.</p>` +
            `<p>3. Скачайте на${NBSP}смартфон приложение ${LAQUO}Умный Дом.ру${RAQUO};. Синхронизируйте с${NBSP}ним ` +
            `камеру и${NBSP}пользуйтесь услугой в${NBSP}любое удобное время.</p>`,
    },
    {
        id: 2,
        question: `Чем отличается умная камера Дом.ру от${NBSP}обычной камеры видеонаблюдения?`,
        answer: `Детектор движения${NBSP}${MDASH} это датчик внутри камеры, который обнаруживает движения объектов ` +
            `в${NBSP}поле зрения камеры. Как только камера фиксирует движение в${NBSP}кадре, включается видеозапись ` +
            `и${NBSP}она длится до${NBSP}прекращения движения. Эта технология позволяет не${NBSP}просматривать ` +
            `многочасовую запись, а${NBSP}получить видео только тех моментов, когда в${NBSP}поле зрения камеры ` +
            'что-то происходило.',
    },
    {
        id: 3,
        question: `Есть${NBSP}ли гарантия на${NBSP}оборудование?`,
        answer: `Гарантия${NBSP}${MDASH} 1${NBSP}год с${NBSP}момента подписания гарантийного талона. Условия ` +
            `не${NBSP}отличаются от${NBSP}любой другой бытовой техники общего пользования.`,
    },
    {
        id: 4,
        question: `Можно${NBSP}ли установить камеры на${NBSP}улице?`,
        answer: `Да, в${NBSP}нашем ассортименте есть как домашние камеры, так и${NBSP}уличные, которые работают при ` +
            `температуре от -40 до${NBSP}+50${NBSP}°C${NBSP}и${NBSP}обладают антивандальным корпусом.`,
    },
    {
        id: 5,
        question: `Смогу${NBSP}ли я${NBSP}просматривать видео с${NBSP}камер, находясь в${NBSP}другом городе ` +
            `или за${NBSP}границей?`,
        answer: `Да, вы${NBSP}можете смотреть видео с${NBSP}камер из${NBSP}любой точки мира. Для этого нужно ` +
            `подключение к${NBSP}сети интернет и${NBSP}авторизация в${NBSP}приложении ${LAQUO}Умный Дом${RAQUO}.`,
    },
    {
        id: 6,
        question: `Можно${NBSP}ли добавить к${NBSP}просмотру видео в${NBSP}приложении ${LAQUO}Умный Дом.ру${RAQUO} ` +
            'своих членов семьи?',
        answer: `Да, в${NBSP}приложении можно настроить семейный доступ к${NBSP}камере и${NBSP}добавить ` +
            `к${NBSP}просмотру членов семьи.`,
    },
    {
        id: 7,
        question: `Есть${NBSP}ли в${NBSP}камерах микрофон?`,
        answer: `Да, в${NBSP}нашем модельном ряду ip-видеокамер есть устройства, оснащенные микрофоном.`,
    },
];

export const videocontrolAdvantagesTabs: TTabs = {
    leftText: 'Внутри',
    rightText: 'Снаружи',
};

export const videocontrolInsideData: IData[] = [
    {
        id: 1,
        question: `Что происходит в${NBSP}квартире`,
        answer: `Не${NBSP}волнуйтесь, камера пришлет уведомление, если кто-то попытается проникнуть внутрь`,
        bgImageXXL: require('~/static/images/videocontrol/advantages/advantages_1_1.png'),
        bgImageXL: require('~/static/images/videocontrol/advantages/advantages_1_L1.png'),
        bgImageL: require('~/static/images/videocontrol/advantages/advantages_1_M1.png'),
        bgImageM: require('~/static/images/videocontrol/advantages/advantages_1_1_1.png'),
        bgImageS: require('~/static/images/videocontrol/advantages/advantages_1_1_2.png'),
        bgImageXXLWebp: require('~/static/images/videocontrol/advantages/advantages_1_1.webp'),
        bgImageXLWebp: require('~/static/images/videocontrol/advantages/advantages_1_L1.webp'),
        bgImageLWebp: require('~/static/images/videocontrol/advantages/advantages_1_M1.webp'),
        bgImageMWebp: require('~/static/images/videocontrol/advantages/advantages_1_1_1.webp'),
        bgImageSWebp: require('~/static/images/videocontrol/advantages/advantages_1_1_2.webp'),
        isHigher: true,
    },
    {
        id: 2,
        question: 'Чем занят ребенок',
        answer: `Узнайте, чем занимается ваш ребенок в${NBSP}ваше отсутствие, и${NBSP}как о${NBSP}нем заботится няня`,
        bgImageXXL: require('~/static/images/videocontrol/advantages/advantages_1_2.png'),
        bgImageXL: require('~/static/images/videocontrol/advantages/advantages_1_L2.png'),
        bgImageL: require('~/static/images/videocontrol/advantages/advantages_1_M2.png'),
        bgImageM: require('~/static/images/videocontrol/advantages/advantages_1_2_1.png'),
        bgImageS: require('~/static/images/videocontrol/advantages/advantages_1_2_2.png'),
        bgImageXXLWebp: require('~/static/images/videocontrol/advantages/advantages_1_2.webp'),
        bgImageXLWebp: require('~/static/images/videocontrol/advantages/advantages_1_L2.webp'),
        bgImageLWebp: require('~/static/images/videocontrol/advantages/advantages_1_M2.webp'),
        bgImageMWebp: require('~/static/images/videocontrol/advantages/advantages_1_2_1.webp'),
        bgImageSWebp: require('~/static/images/videocontrol/advantages/advantages_1_2_2.webp'),
        isHigher: true,
    },
    {
        id: 3,
        question: `Следите за${NBSP}ходом ремонта`,
        answer: `Следите в${NBSP}режиме онлайн за${NBSP}ходом ремонтных работ, не${NBSP}выезжая на${NBSP}объект`,
        bgImageXXL: require('~/static/images/videocontrol/advantages/advantages_1_3.png'),
        bgImageXL: require('~/static/images/videocontrol/advantages/advantages_1_L3.png'),
        bgImageL: require('~/static/images/videocontrol/advantages/advantages_1_M3.png'),
        bgImageM: require('~/static/images/videocontrol/advantages/advantages_1_3_1.png'),
        bgImageS: require('~/static/images/videocontrol/advantages/advantages_1_3_2.png'),
        bgImageXXLWebp: require('~/static/images/videocontrol/advantages/advantages_1_3.webp'),
        bgImageXLWebp: require('~/static/images/videocontrol/advantages/advantages_1_L3.webp'),
        bgImageLWebp: require('~/static/images/videocontrol/advantages/advantages_1_M3.webp'),
        bgImageMWebp: require('~/static/images/videocontrol/advantages/advantages_1_3_1.webp'),
        bgImageSWebp: require('~/static/images/videocontrol/advantages/advantages_1_3_2.webp'),
    },
    {
        id: 4,
        question: `Наблюдайте за${NBSP}питомцами`,
        answer: `Будьте в${NBSP}курсе, чем заняты домашние животные в${NBSP}ваше отсутствие`,
        bgImageXXL: require('~/static/images/videocontrol/advantages/advantages_1_4.png'),
        bgImageXL: require('~/static/images/videocontrol/advantages/advantages_1_L4.png'),
        bgImageL: require('~/static/images/videocontrol/advantages/advantages_1_M4.png'),
        bgImageM: require('~/static/images/videocontrol/advantages/advantages_1_4_1.png'),
        bgImageS: require('~/static/images/videocontrol/advantages/advantages_1_4_2.png'),
        bgImageXXLWebp: require('~/static/images/videocontrol/advantages/advantages_1_4.webp'),
        bgImageXLWebp: require('~/static/images/videocontrol/advantages/advantages_1_L4.webp'),
        bgImageLWebp: require('~/static/images/videocontrol/advantages/advantages_1_M4.webp'),
        bgImageMWebp: require('~/static/images/videocontrol/advantages/advantages_1_4_1.webp'),
        bgImageSWebp: require('~/static/images/videocontrol/advantages/advantages_1_4_2.webp'),
    },
    {
        id: 5,
        question: `Заботьтесь о${NBSP}родителях`,
        answer: `Узнавайте, как дела у${NBSP}пожилых родственников и${NBSP}быстро реагируйте в${NBSP}случае${NBSP}ЧС`,
        bgImageXXL: require('~/static/images/videocontrol/advantages/advantages_1_5.png'),
        bgImageXL: require('~/static/images/videocontrol/advantages/advantages_1_L5.png'),
        bgImageL: require('~/static/images/videocontrol/advantages/advantages_1_M5.png'),
        bgImageM: require('~/static/images/videocontrol/advantages/advantages_1_5_1.png'),
        bgImageS: require('~/static/images/videocontrol/advantages/advantages_1_5_2.png'),
        bgImageXXLWebp: require('~/static/images/videocontrol/advantages/advantages_1_5.webp'),
        bgImageXLWebp: require('~/static/images/videocontrol/advantages/advantages_1_L5.webp'),
        bgImageLWebp: require('~/static/images/videocontrol/advantages/advantages_1_M5.webp'),
        bgImageMWebp: require('~/static/images/videocontrol/advantages/advantages_1_5_1.webp'),
        bgImageSWebp: require('~/static/images/videocontrol/advantages/advantages_1_5_2.webp'),
    },
];

export const videocontrolOutsideData: IData[] = [
    {
        id: 1,
        question: `Всё${NBSP}ли в${NBSP}порядке на${NBSP}даче`,
        answer: `Будьте спокойны за${NBSP}дом и${NBSP}участок даже в${NBSP}отпуске`,
        bgImageXXL: require('~/static/images/videocontrol/advantages/advantages_2_1.png'),
        bgImageXL: require('~/static/images/videocontrol/advantages/advantages_2_L1.png'),
        bgImageL: require('~/static/images/videocontrol/advantages/advantages_2_M1.png'),
        bgImageM: require('~/static/images/videocontrol/advantages/advantages_2_1_1.png'),
        bgImageS: require('~/static/images/videocontrol/advantages/advantages_2_1_2.png'),
        bgImageXXLWebp: require('~/static/images/videocontrol/advantages/advantages_2_1.webp'),
        bgImageXLWebp: require('~/static/images/videocontrol/advantages/advantages_2_L1.webp'),
        bgImageLWebp: require('~/static/images/videocontrol/advantages/advantages_2_M1.webp'),
        bgImageMWebp: require('~/static/images/videocontrol/advantages/advantages_2_1_1.webp'),
        bgImageSWebp: require('~/static/images/videocontrol/advantages/advantages_2_1_2.webp'),
        isHigher: true,
    },
    {
        id: 2,
        question: `Как дела у${NBSP}детей на${NBSP}прогулке`,
        answer: `Проверяйте, всё${NBSP}ли хорошо у${NBSP}детей на${NBSP}игровой площадке`,
        bgImageXXL: require('~/static/images/videocontrol/advantages/advantages_2_2.png'),
        bgImageXL: require('~/static/images/videocontrol/advantages/advantages_2_L2.png'),
        bgImageL: require('~/static/images/videocontrol/advantages/advantages_2_M2.png'),
        bgImageM: require('~/static/images/videocontrol/advantages/advantages_2_2_1.png'),
        bgImageS: require('~/static/images/videocontrol/advantages/advantages_2_2_2.png'),
        bgImageXXLWebp: require('~/static/images/videocontrol/advantages/advantages_2_2.webp'),
        bgImageXLWebp: require('~/static/images/videocontrol/advantages/advantages_2_L2.webp'),
        bgImageLWebp: require('~/static/images/videocontrol/advantages/advantages_2_M2.webp'),
        bgImageMWebp: require('~/static/images/videocontrol/advantages/advantages_2_2_1.webp'),
        bgImageSWebp: require('~/static/images/videocontrol/advantages/advantages_2_2_2.webp'),
        isHigher: true,
    },
    {
        id: 3,
        question: `Кто заходит в${NBSP}подъезд`,
        answer: `Будьте уверены, что в${NBSP}подъезде нет посторонних`,
        bgImageXXL: require('~/static/images/videocontrol/advantages/advantages_2_3.png'),
        bgImageXL: require('~/static/images/videocontrol/advantages/advantages_2_L3.png'),
        bgImageL: require('~/static/images/videocontrol/advantages/advantages_2_M3.png'),
        bgImageM: require('~/static/images/videocontrol/advantages/advantages_2_3_1.png'),
        bgImageS: require('~/static/images/videocontrol/advantages/advantages_2_3_2.png'),
        bgImageXXLWebp: require('~/static/images/videocontrol/advantages/advantages_2_3.webp'),
        bgImageXLWebp: require('~/static/images/videocontrol/advantages/advantages_2_L3.webp'),
        bgImageLWebp: require('~/static/images/videocontrol/advantages/advantages_2_M3.webp'),
        bgImageMWebp: require('~/static/images/videocontrol/advantages/advantages_2_3_1.webp'),
        bgImageSWebp: require('~/static/images/videocontrol/advantages/advantages_2_3_2.webp'),
        isLaptopImage: true,
    },
    {
        id: 4,
        question: `Порядок на${NBSP}территории дома`,
        answer: `Проверьте онлайн, что происходит на${NBSP}участке загородного дома`,
        bgImageXXL: require('~/static/images/videocontrol/advantages/advantages_2_4.png'),
        bgImageXL: require('~/static/images/videocontrol/advantages/advantages_2_L4.png'),
        bgImageL: require('~/static/images/videocontrol/advantages/advantages_2_M4.png'),
        bgImageM: require('~/static/images/videocontrol/advantages/advantages_2_4_1.png'),
        bgImageS: require('~/static/images/videocontrol/advantages/advantages_2_4_2.png'),
        bgImageXXLWebp: require('~/static/images/videocontrol/advantages/advantages_2_4.webp'),
        bgImageXLWebp: require('~/static/images/videocontrol/advantages/advantages_2_L4.webp'),
        bgImageLWebp: require('~/static/images/videocontrol/advantages/advantages_2_M4.webp'),
        bgImageMWebp: require('~/static/images/videocontrol/advantages/advantages_2_4_1.webp'),
        bgImageSWebp: require('~/static/images/videocontrol/advantages/advantages_2_4_2.webp'),
    },
    {
        id: 5,
        question: `Свободно${NBSP}ли место на${NBSP}парковке`,
        answer: `Найдите себе удобное место на${NBSP}парковке`,
        bgImageXXL: require('~/static/images/videocontrol/advantages/advantages_2_5.png'),
        bgImageXL: require('~/static/images/videocontrol/advantages/advantages_2_L5.png'),
        bgImageL: require('~/static/images/videocontrol/advantages/advantages_2_M5.png'),
        bgImageM: require('~/static/images/videocontrol/advantages/advantages_2_5_1.png'),
        bgImageS: require('~/static/images/videocontrol/advantages/advantages_2_5_2.png'),
        bgImageXXLWebp: require('~/static/images/videocontrol/advantages/advantages_2_5.webp'),
        bgImageXLWebp: require('~/static/images/videocontrol/advantages/advantages_2_L5.webp'),
        bgImageLWebp: require('~/static/images/videocontrol/advantages/advantages_2_M5.webp'),
        bgImageMWebp: require('~/static/images/videocontrol/advantages/advantages_2_5_1.webp'),
        bgImageSWebp: require('~/static/images/videocontrol/advantages/advantages_2_5_2.webp'),
        isLaptopImage: true,
    },
];

export const headerItems: IHeaderItems[] = [
    {
        icon: require('~/static/images/videocontrol/icons/movement-reaction.svg'),
        text: 'Реагирует на движения',
    },
    {
        icon: require('~/static/images/videocontrol/icons/observe.svg'),
        text: 'Сообщит, если кто-то проник внутрь',
    },
    {
        icon: require('~/static/images/videocontrol/icons/app.svg'),
        text: 'Управляется из приложения в режиме онлайн',
    },
];


export const headerPictures: IHeaderPictures[] = [
    {
        png: require('~/static/images/videocontrol/header/camera_office.png'),
        webp: require('~/static/images/videocontrol/header/camera_office.webp'),
        text: 'Квартира',
    },
    {
        png: require('~/static/images/videocontrol/header/camera_country_house.png'),
        webp: require('~/static/images/videocontrol/header/camera_country_house.webp'),
        text: 'Загородный дом',
    },
    {
        png: require('~/static/images/videocontrol/header/camera_porch.png'),
        webp: require('~/static/images/videocontrol/header/camera_porch.webp'),
        text: 'Подъезд',
    },
];

export const featuresData: IFeaturesData[] = [
    {
        id: 1,
        png: require('~/static/images/videocontrol/features/picture_1.png'),
        webp: require('~/static/images/videocontrol/features/picture_1.webp'),
        title: `Просматривайте записи в${NBSP}приложении`,
        text: `Проверяйте, как дела дома с${NBSP}экрана смартфона, получайте уведомления о${NBSP}событиях.`,
    },
    {
        id: 2,
        png: require('~/static/images/videocontrol/features/picture_2.png'),
        webp: require('~/static/images/videocontrol/features/picture_2.webp'),
        title: 'Рассмотрите все детали',
        text: `Вы${NBSP}сможете рассмотреть все детали и${NBSP}лица даже на${NBSP}ночных записях.`,
    },
    {
        id: 3,
        png: require('~/static/images/videocontrol/features/picture_3.png'),
        webp: require('~/static/images/videocontrol/features/picture_3.webp'),
        title: `Будьте уверены в${NBSP}безопасности данных`,
        text: `Все записи с${NBSP}камер хранятся в${NBSP}защищенном облачном хранилище, доступ к${NBSP}которому ` +
            `имеете только${NBSP}вы`,
    },
    {
        id: 4,
        png: require('~/static/images/videocontrol/features/picture_4.png'),
        webp: require('~/static/images/videocontrol/features/picture_4.webp'),
        title: `Будьте в${NBSP}курсе всех событий`,
        text: `Если в${NBSP}доме кто-то появится в${NBSP}ваше отсутствие, камера распознает движение ` +
            `и${NBSP}отправит уведомление в${NBSP}мобильном приложении Умный Дом.ру.`,
    },
];

export enum ELocation {
    flat = 'flat',
    entrance = 'entrance',
    area = 'area',
    home = 'home',
}

export enum ELocationOuter {
    entrance = 'entrance',
    area = 'area',
}

export const locationForReducer: Record<ELocation, TPlace> = {
    [ELocation.flat]: {
        type: ELocation.flat,
        id: 1,
        priceTotal: 1,
        currencyType: '₽',
        name: 'Внутри квартиры',
        service: 'Установка',
        priceTotalWithCount: 1,
    },
    [ELocation.entrance]: {
        type: ELocation.entrance,
        id: 2,
        priceTotal: 1000,
        currencyType: '₽',
        name: 'В подъезде',
        service: 'Установка',
        priceTotalWithCount: 1000,
    },
    [ELocation.area]: {
        type: ELocation.area,
        id: 3,
        priceTotal: 1500,
        currencyType: '₽',
        name: 'На участке',
        service: 'Установка',
        priceTotalWithCount: 1500,
    },
    [ELocation.home]: {
        type: ELocation.home,
        id: 4,
        priceTotal: 1,
        currencyType: '₽',
        name: 'В доме',
        service: 'Установка',
        priceTotalWithCount: 1,
    },
};

export const dataLocationFlat: TTabSteps[] = [
    {
        imgPng: require('~/static/images/videocontrol/steps-install/flat.png'),
        imgWebP: require('~/static/images/videocontrol/steps-install/flat.webp'),
        title: 'Внутри квартиры',
        subText: `Имущество и${NBSP}жильцы всегда под присмотром`,
        id: ELocation.flat,
    },
    {
        imgPng: require('~/static/images/videocontrol/steps-install/entrance.png'),
        imgWebP: require('~/static/images/videocontrol/steps-install/entrance.webp'),
        title: `В${NBSP}подъезде`,
        subText: `Чистота и${NBSP}безопасность без посторонних людей`,
        id: ELocation.entrance,
    },
];

const dataLocationHome = [
    {
        imgPng: require('~/static/images/videocontrol/steps-install/area.png'),
        imgWebP: require('~/static/images/videocontrol/steps-install/area.webp'),
        title: `На${NBSP}участке`,
        subText: `Присматривайте за${NBSP}дачей и${NBSP}любимым садом`,
        id: ELocation.area,
    },
    {
        imgPng: require('~/static/images/videocontrol/steps-install/home.png'),
        imgWebP: require('~/static/images/videocontrol/steps-install/home.webp'),
        title: `В${NBSP}доме`,
        subText: 'Имущество всегда под присмотром',
        id: ELocation.home,
    },
];

export const dataCameraPlans: IDataPlans[] = [
    {
        id: 1,
        title: 'Видеоконтроль 3',
        subText: `Для тех, кто хочет видеть события за${NBSP}3${NBSP}дня`,
        panelText: `Хранение архива 3${NBSP}дня`,
        propsText: ['Качество изображения Full HD', 'Запись по движению'],
        price: 200,
        priceMonthWithCount: 200,
        oldPrice: null,
    },
    {
        id: 2,
        title: 'Видеоконтроль 7',
        subText: `Для тех, кто хочет видеть события за${NBSP}1${NBSP}неделю`,
        panelText: `Хранение архива 7${NBSP}дней`,
        propsText: ['Качество изображения Full HD', 'Запись по движению'],
        price: 350,
        priceMonthWithCount: 350,
        oldPrice: null,
    },
    {
        id: 3,
        title: 'Видеоконтроль 14',
        subText: `Для тех, кто хочет видеть события за${NBSP}2${NBSP}недели`,
        panelText: `Хранение архива 14${NBSP}дней`,
        propsText: ['Качество изображения Full HD', 'Запись по движению'],
        price: 450,
        priceMonthWithCount: 450,
        oldPrice: null,
    },
    {
        id: 4,
        title: 'Видеоконтроль 30',
        subText: `Для тех, кто хочет видеть события за${NBSP}1${NBSP}месяц`,
        panelText: `Хранение архива 30${NBSP}дней`,
        propsText: ['Качество изображения Full HD', 'Запись по движению'],
        price: 650,
        priceMonthWithCount: 650,
        oldPrice: null,
    },
];

export const injectorData: TInjector = {
    name: 'POE Tenda PoE15F',
    service: 'Покупка',
    currencyType: '₽',
    id: 1,
    priceTotal: 800,
    priceTotalWithCount: 800,
    count: 0,
};

export const dataTabsForLoc = { leftText: 'Квартира', rightText: 'Частный дом' };

export const dataLocation = { [dataTabsForLoc.leftText]: dataLocationFlat, [dataTabsForLoc.rightText]: dataLocationHome };

export const mockedVideoCamerasData = [
    {
        id: 107530,
        image: '',
        image_webp: '',
        category: {
            title: 'Внутренняя камера',
            name: 'Dahua IMOU Cue 2',
        },
        title: 'Dahua IMOU Cue 2',
        shortName: 'Dahua IMOU Cue 2',
        title_short: 'Dahua IMOU Cue 2',
        body: 'Подключение по Wi-Fi\n Ночная съемка до 10 м\n Запись в облако',
        bgImgColor: '#20252f',
        bgColorCard: '#20252f',
        priceOptions: [
            {
                label: 36,
                operType: 'leasing',
                price: 160,
                type: 5,
                sort: null,
                value: 36,
            },
            {
                label: 24,
                operType: 'leasing',
                price: 230,
                type: 5,
                sort: null,
                value: 24,
            },
            {
                label: 12,
                operType: 'leasing',
                price: 390,
                sort: null,
                type: 5,
                value: 12,
            },
            {
                label: 6,
                operType: 'leasing',
                price: 660,
                sort: null,
                type: 5,
                value: 6,
            },
            {
                label: 0,
                operType: 'possess',
                price: 3960,
                sort: null,
                type: 1,
                value: 0,
            },
        ],
    },
];
